"use strict";

function startActionLoading($form) {
    var $actions = $form.closest(".seguimiento-cancellation-choice__actions");

    $form.data("submitting", true);
    $actions.find("button[type='submit']")
        .prop("disabled", true)
        .attr("aria-disabled", "true");

    $.spinner().start();
}

module.exports = function () {
    $("body").on("submit", ".seguimiento-cancellation-choice__form", function () {
        var $form = $(this);

        if ($form.data("submitting")) {
            return false;
        }

        startActionLoading($form);

        return true;
    });
};
